module.exports = __webpack_public_path__ + "static/cx-description-3cb0e38463c961af786203e938563ed1.jpg";